import React, { ReactElement } from 'react';
import { TableTreeColumn } from '@devexpress/dx-react-grid-material-ui';
import { CheckboxProps } from '@mui/material';

interface CustomTreeCellProps extends TableTreeColumn.CellProps {
  readonly rowSelectionDisabled: (row: any) => boolean;
  readonly rowSelectionHidden?: (row: any) => boolean;
  readonly rowSelectionIndeterminate?: (row: any) => boolean;
}

/** This is the best way I could find to be able to disable the checkbox for certain rows. It's not pretty, but it
 * achieves the stated goal. This is based off of https://github.com/DevExpress/devextreme-reactive/issues/2667 and the
 * accompanying code example. Readers are welcome to find a better solution.
 */
export function CustomTreeCell(props: CustomTreeCellProps) {
  const { children, rowSelectionDisabled, rowSelectionHidden, rowSelectionIndeterminate, ...restProps } = props;
  const newChildren = React.Children.map(children, (child, index) => {
    if (!child || index !== 2) return child; // Index 2 is the checkbox we want to disable, per the link above
    return rowSelectionHidden && rowSelectionHidden(props.row)
      ? null
      : React.cloneElement(child as ReactElement<CheckboxProps>, {
          disabled: rowSelectionDisabled(props.row),
          indeterminate: rowSelectionIndeterminate ? rowSelectionIndeterminate(props.row) : undefined,
        });
  });

  return <TableTreeColumn.Cell {...restProps}>{newChildren}</TableTreeColumn.Cell>;
}
